import { useState } from "react";
import { Plus } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { useAuth } from "@/lib/auth";
import { usePermissao } from "@/lib/use-permissao";
import { agendaViewRange, type AgendaViewMode, type WeekAppointment } from "@/lib/dashboard-week";
import { WeekAgenda } from "@/components/dashboard2/WeekAgenda";
import { useNovaConsulta } from "@/components/agenda/use-nova-consulta";
import { SemPermissao } from "./SemPermissao";

/** Agenda da organização em foco — o widget do Início, com o detalhe de cada consulta e o "Nova
 *  consulta", que marca nela (o diálogo não oferece trocar de clínica aqui dentro). */
export function PainelAgenda() {
  const { user } = useAuth();
  const podeVer = usePermissao("agenda.view");
  const podeMarcar = usePermissao("agenda.manage");
  const novaConsulta = useNovaConsulta();
  const [modo, setModo] = useState<AgendaViewMode>("week");
  const faixa = agendaViewRange(modo);
  const consultas = trpc.appointment.listByRange.useQuery(
    { rangeStart: faixa.start, rangeEnd: faixa.end },
    { enabled: podeVer },
  );

  if (!podeVer) return <SemPermissao area="a agenda" />;
  const org = user?.activeOrganization;
  const appts: WeekAppointment[] = ((consultas.data ?? []) as WeekAppointment[]).map((a) => ({
    ...a,
    organizationId: org?.id ?? "",
    organizationName: org?.name ?? "",
  }));

  return (
    <div className="space-y-3">
      {podeMarcar && (
        <div className="flex justify-end">
          <button
            type="button"
            onClick={novaConsulta.abrir}
            disabled={!novaConsulta.pronto}
            className="inline-flex h-10 items-center gap-1.5 rounded-md bg-brand-600 px-3 text-[13px] font-semibold text-white shadow-sm transition-colors hover:bg-brand-700 disabled:opacity-60"
          >
            <Plus className="h-4 w-4" />
            Nova consulta
          </button>
        </div>
      )}
      {/* `readOnly` aqui só tira o "Ver agenda completa", que abriria a agenda da organização
          ativa; o detalhe da consulta continua abrindo, já falando com a organização em foco. */}
      <WeekAgenda appts={appts} loading={consultas.isLoading} viewMode={modo} onViewModeChange={setModo} readOnly />
      {novaConsulta.elementos}
    </div>
  );
}
